import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import type { StoreProduct } from '../types';

interface State {
  products: StoreProduct[];
  loading: boolean;
  error: string | null;
}

export function useStoreProducts(slug: string): State {
  const [state, setState] = useState<State>({
    products: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    setState({ products: [], loading: true, error: null });

    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/stores/${encodeURIComponent(slug)}/products?limit=100`,
        );
        if (!res.ok) {
          throw new Error(`Failed to load products (${res.status})`);
        }
        const json = await res.json();
        const products: StoreProduct[] = json?.data?.products ?? json?.products ?? [];
        if (!cancelled) {
          setState({ products, loading: false, error: null });
        }
      } catch (err) {
        if (!cancelled) {
          setState({
            products: [],
            loading: false,
            error: err instanceof Error ? err.message : 'Failed to load products',
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  return state;
}